import { Link } from "react-router-dom";

const footerLinks = [
  { name: "Home", link: "/" },
  { name: "Services", link: "/services" },
  { name: "Clients", link: "/clients" },
  { name: "Contact", link: "/contact" },
];
export function Footer() {
  return (
    <footer className="bg-dark text-light mt-auto">
      <div className="container py-5">
        <div className="row g-4">
          {/* Brand Section */}
          <div className="col-lg-4 mb-4 mb-lg-0">
            <h5 className="fw-bold mb-3">
              Last<span className="text-warning">Mile</span>Service
            </h5>
            <p className="text-light opacity-75 mb-3">
              Pioneering AI-powered Software Developemt solutions for
              next-generation system.
            </p>
            <div className="social-links">
              <a
                href="https://www.linkedin.com/company/last-mile-services-acs"
                className="text-light opacity-75 me-3 text-decoration-none"
                aria-label="LinkedIn"
              >
                <i className="bi bi-linkedin fs-5"></i>
              </a>
              {/* <a
                href="#"
                className="text-light opacity-75 me-3 text-decoration-none"
                aria-label="Twitter"
              >
                <i className="bi bi-twitter fs-5"></i>
              </a> */}
              <a
                href="mailto:contact@lastmileservice.in"
                className="text-light opacity-75 text-decoration-none"
                aria-label="Email"
              >
                <i className="bi bi-envelope fs-5"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-lg-2 col-md-4 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3">Quick Links</h6>
            <ul className="list-unstyled">
              {footerLinks.map((item, index) => (
                <li className="mb-2" key={index}>
                  <Link
                    to={item.link}
                    className="text-light opacity-75 text-decoration-none"
                    onClick={() =>
                      window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                      })
                    }
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="col-lg-3 col-md-4 mb-4 mb-lg-0">
            <h6 className="fw-bold mb-3">Our Services</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <span className="text-light opacity-75">
                  AI Software Development
                </span>
              </li>
              <li className="mb-2">
                <span className="text-light opacity-75">Computer Vision</span>
              </li>
              <li className="mb-2">
                <span className="text-light opacity-75">
                  System Integration
                </span>
              </li>
              <li className="mb-2">
                <span className="text-light opacity-75">
                  Technical and Sofware Development Consulting
                </span>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-3 col-md-4">
            <h6 className="fw-bold mb-3">Contact</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <i className="bi bi-geo-alt-fill text-warning me-2"></i>
                <span className="text-light opacity-75 small">
                  Dehradun, Uttarakhand
                </span>
              </li>
              <li className="mb-2">
                <i className="bi bi-telephone-fill text-warning me-2"></i>
                <a
                  href="tel:+918860179948"
                  className="text-light opacity-75 text-decoration-none small"
                >
                  +91 88601 79948
                </a>
              </li>
              <li className="mb-2">
                <i className="bi bi-envelope-fill text-warning me-2"></i>
                <a
                  href="mailto:contact@lastmileservice.in"
                  className="text-light opacity-75 text-decoration-none small"
                >
                  contact@lastmileservice.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        <hr className="my-4 border-secondary opacity-25" />

        <div className="row">
          <div className="col-md-6 mb-2 mb-md-0">
            <p className="small text-light opacity-75 mb-0">
              © 2026 Adrija Consultancy Services LLP. All rights reserved.
            </p>
          </div>
          <div className="col-md-6 text-md-end">
            <p className="small text-light opacity-75 mb-0">
              Shaping the Future Through Smart Software
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
